// Mock data for Groupe Neema Landing Page

export const companyInfo = {
  name: "Groupe Neema",
  tagline: "Excellence et Innovation au Service de Votre Entreprise",
  description: "Groupe Neema est votre partenaire de confiance pour accompagner la croissance et la transformation de votre entreprise. Nous offrons des solutions sur mesure adaptées à vos besoins spécifiques.",
  email: "contact@groupeneema.com",
  address: "Nancy, France",
  siret: "981765399"
};

export const heroContent = {
  title: "Groupe Neema",
  subtitle: "Votre Partenaire Stratégique pour la Réussite de Votre Entreprise",
  description: "Solutions professionnelles innovantes et accompagnement personnalisé pour propulser votre activité vers de nouveaux sommets.",
  ctaText: "Découvrir nos services",
  image: "https://images.unsplash.com/photo-1573164574572-cb89e39749b4"
};

export const services = [
  {
    id: 1,
    icon: "Briefcase",
    title: "Conseil en Stratégie",
    description: "Développez votre vision stratégique avec nos experts. Nous vous accompagnons dans la définition et la mise en œuvre de stratégies gagnantes.",
    image: "https://images.unsplash.com/photo-1758518729912-bf3a84c400e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHRlYW18ZW58MHx8fHwxNzY4NTU1MzI1fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    icon: "TrendingUp",
    title: "Développement Commercial",
    description: "Boostez votre croissance avec nos solutions commerciales innovantes. Optimisation des processus et expansion de votre marché.",
    image: "https://images.unsplash.com/photo-1736836977797-8035ae65c0f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxvZmZpY2UlMjB3b3JrcGxhY2V8ZW58MHx8fHwxNzY4NTU1MzMzfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    icon: "Users",
    title: "Gestion des Ressources",
    description: "Optimisez la gestion de vos équipes et ressources. Solutions RH modernes pour maximiser la performance et l'engagement.",
    image: "https://images.unsplash.com/photo-1716635174919-e6aec2d1c45a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxvZmZpY2UlMjB3b3JrcGxhY2V8ZW58MHx8fHwxNzY4NTU1MzMzfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    icon: "LineChart",
    title: "Analyse & Performance",
    description: "Prenez des décisions éclairées grâce à nos analyses approfondies. Tableaux de bord et indicateurs de performance sur mesure.",
    image: "https://images.unsplash.com/photo-1556761175-4b46a572b786?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjB3b3JrcGxhY2V8ZW58MHx8fHwxNzY4NTU1MzMzfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    icon: "Lightbulb",
    title: "Innovation & Transformation",
    description: "Transformez votre entreprise avec les dernières innovations. Accompagnement dans la transformation digitale et organisationnelle.",
    image: "https://images.unsplash.com/photo-1758611972613-3afe657c3249?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxvZmZpY2UlMjB3b3JrcGxhY2V8ZW58MHx8fHwxNzY4NTU1MzMzfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 6,
    icon: "Shield",
    title: "Conformité & Sécurité",
    description: "Assurez la conformité de votre entreprise. Audit, conseil et mise en place de procédures conformes aux réglementations.",
    image: "https://images.unsplash.com/photo-1581093805071-a04e696db334?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHRlYW18ZW58MHx8fHwxNzY4NTU1MzI1fDA&ixlib=rb-4.1.0&q=85"
  }
];

export const aboutContent = {
  title: "À Propos de Groupe Neema",
  subtitle: "Une Expertise au Service de Votre Réussite",
  description: "Depuis notre création, Groupe Neema s'est imposé comme un acteur majeur dans l'accompagnement des entreprises. Notre équipe d'experts passionnés met son savoir-faire au service de votre croissance et de votre succès.",
  highlights: [
    { label: "Années d'Expérience", value: "10+" },
    { label: "Clients Satisfaits", value: "200+" },
    { label: "Projets Réalisés", value: "500+" },
    { label: "Taux de Satisfaction", value: "98%" }
  ],
  values: [
    {
      icon: "Target",
      title: "Excellence",
      description: "Nous visons l'excellence dans chaque projet, en délivrant des solutions de haute qualité."
    },
    {
      icon: "Heart",
      title: "Engagement",
      description: "Nous nous engageons pleinement auprès de nos clients pour garantir leur succès."
    },
    {
      icon: "Sparkles",
      title: "Innovation",
      description: "Nous adoptons les dernières innovations pour offrir des solutions à la pointe."
    }
  ],
  image: "https://images.unsplash.com/photo-1763550662603-78aa2f2033bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHRlYW18ZW58MHx8fHwxNzY4NTU1MzI1fDA&ixlib=rb-4.1.0&q=85"
};

export const team = [
  {
    id: 1,
    name: "Sophie Martin",
    role: "Directrice Générale",
    bio: "15 ans d'expérience en stratégie d'entreprise",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop"
  },
  {
    id: 2,
    name: "Jean Dupont",
    role: "Directeur Commercial",
    bio: "Expert en développement commercial B2B",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop"
  },
  {
    id: 3,
    name: "Marie Leblanc",
    role: "Directrice des Opérations",
    bio: "Spécialiste en optimisation des processus",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Pierre Rousseau",
    role: "CEO, TechCorp",
    content: "Groupe Neema a transformé notre approche commerciale. Leur expertise et leur professionnalisme sont exceptionnels.",
    rating: 5
  },
  {
    id: 2,
    name: "Claire Bernard",
    role: "Directrice, InnovSolutions",
    content: "Un partenaire de confiance qui nous accompagne depuis 3 ans. Résultats tangibles et service impeccable.",
    rating: 5
  },
  {
    id: 3,
    name: "Marc Lefebvre",
    role: "Fondateur, StartupPro",
    content: "Grâce à Groupe Neema, nous avons doublé notre chiffre d'affaires en 18 mois. Je les recommande vivement.",
    rating: 5
  }
];

export const contactInfo = {
  title: "Contactez-Nous",
  subtitle: "Parlons de Votre Projet",
  description: "Notre équipe est à votre disposition pour discuter de vos besoins et vous proposer des solutions adaptées.",
  methods: [
    {
      icon: "Mail",
      label: "Email",
      value: "contact@groupeneema.com",
      link: "mailto:contact@groupeneema.com"
    },
    {
      icon: "MapPin",
      label: "Adresse",
      value: "Nancy, France",
      link: "#"
    }
  ]
};
